export default __webpack_public_path__ + "static/Ringside-Medium-a404327ee92127927d4b698d1fd59f5a.woff2";